import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_v_icon, {
      class: "mb-5",
      color: "amber-lighten-3",
      icon: "mdi-close-circle-outline",
      size: "112"
    }),
    _hoisted_4,
    _createVNode(_component_v_card_title, null, {
      default: _withCtx(() => [
        _createTextVNode("Что-то пошло не так")
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, {
      width: "320px",
      class: "d-inline-flex flex-column justify-start"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, null, {
          default: _withCtx(() => [
            (_ctx.$route.query['text'])
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$route.query['text']), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, { onClick: _ctx.close }, {
              default: _withCtx(() => [
                _createTextVNode(" OK ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}